<template>
	<div class="no-wrap has-background-white" style="width:100%; height:95vh;">
        <div class="columns">
        	<div class="column is-4">
        		<invoice-filter :params.sync="params" @filter="refetch" />
        	</div>
        	<div class="column is-4">
        		<invoice-table :filter="params" :invoice.sync="invoice" ref="invoiceTable" />
        	</div>
        	<div class="column is-4">
        		<invoice-form :invoice.sync="invoice" @refetch="refetch" />
        	</div>
        </div>
    </div>
</template>
<script>
import InvoiceFilter from "./filter";
import InvoiceTable from "./table";
import InvoiceForm from "./form";
export default {
   	components: {
    	InvoiceFilter, InvoiceTable, InvoiceForm
  	},
    data: () => ({
    	params: null,
    	invoice: null,
    }),
    methods: {
    	refetch() {
            this.invoice = null;
    		this.$refs.invoiceTable.fetch();
    	},
    },
    mounted() {
        // console.log('test');
    },
};
</script>


// WEBPACK FOOTER //
// src/components/pages/invoices/index.vue